import { useConversationUrl } from '@hooks/use-conversation-url';
import { useAppSelector } from '@redux/hooks';
import RfqModal from '@tkmp/rfq/components/RfqModal/RfqModal';
import { useInlineRfqForm } from '@tkmp/rfq/hooks/useInlineRfqForm/useInlineRfqForm';
import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router';

const OPEN_RFQ_PARAM = 'openRfq';

export const RfqDeeplink = () => {
	const location = useLocation();
	const vendorId = useAppSelector((state) => state.vendor.vendor?.id);
	const conversationUrl = useConversationUrl(vendorId);
	const hasTriggered = useRef(false);

	const formContext = useInlineRfqForm({
		freeTextLabel:
			'Say hello and ask a question about style, budget or availability.',
		initiator: 'Vendor Manager',
		headerText: 'Start the convo',
	});

	useEffect(() => {
		if (hasTriggered.current) return;

		const params = new URLSearchParams(location.search);
		const shouldOpenRfq = params.get(OPEN_RFQ_PARAM) === 'true';

		if (!shouldOpenRfq || conversationUrl) return;

		hasTriggered.current = true;
		formContext.openModal();

		// Clean the query param from the URL
		params.delete(OPEN_RFQ_PARAM);
		const cleanSearch = params.toString();
		const cleanUrl = `${location.pathname}${cleanSearch ? `?${cleanSearch}` : ''}`;
		window.history.replaceState(null, '', cleanUrl);
	}, [
		location.search,
		location.pathname,
		conversationUrl,
		formContext.openModal,
	]);

	return <RfqModal context={formContext} />;
};
